import ROUTES from 'routes/routeConstants';

export enum NotificationType {
  LINK = 'link',
  REQUIRE_ACTION = 'REQUIRE_ACTION',
  DIRECT_MESSAGE = 'DIRECT_MESSAGE',
}

export enum NotificationSubType {
  APPOINTMENT_ASSIGNED = 'APPOINTMENT_ASSIGNED',
  APPOINTMENT_REJECTED = 'APPOINTMENT_REJECTED',
  APPOINTMENT_APPROVED = 'APPOINTMENT_APPROVED',
}

export enum NotificationScope {
  USER = 'USER',
  GROUP = 'GROUP',
  BROAD_CAST = 'BOARD_CAST',
}

export enum NotificationStatus {
  READ = 'READ',
  UNREAD = 'UNREAD',
}

export interface INotification {
  id: string;
  read: boolean;
  title: string;
  description: string;
  sender?: string;
  receiver?: string;
  type?: NotificationType;
  subType?: NotificationSubType;
  icon: any;
  image?: any;
  scope: NotificationScope;
  createdAt: Date;
  status: NotificationStatus;
  link?: ROUTES | string;
  onClick?: () => void;
  name: any;
  data: any;
}

export type NotificationUI = {
  isOpen: boolean;
};
